<template>
    <section>
        <div class="text-subtitle-1 font-weight-bold mb-3">{{ titulo }}</div>
        <v-row>
        <v-col cols="12" sm="6" lg="3" v-for="(item,index) in totales" :key="index">
            <v-card variant="outlined" rounded="lg" class="pa-4">
                <div class="d-flex align-center" style="gap: 16px">
                    <v-avatar size="56">
                        <v-img :src="urlImagen(item.imagen)"></v-img>
                    </v-avatar>
                    <div>
                        <div class="text-caption text-muted">{{ item.nombre }}</div>
                        <div class="text-h6 font-weight-bold">{{ item.total }}</div>
                    </div>
                </div>
                <v-divider class="my-3"></v-divider>
                <v-rating
                    color="warning"
                    :model-value="numeroEstrellas(item.total)"
                    half-increments
                    readonly
                    density="compact"
                    ></v-rating>
            </v-card>
        </v-col>
        </v-row>
    </section>
</template>
<script>
import Utiles from '../../Servicios/Utiles'

export default {
    name: "CartasTotalesMiembros",
    props: ["totales", "titulo"],

    data:()=>({
        numeroMayor: 0
    }),

    mounted(){
        this.numeroMayor = this.totales[0].total
    },

    methods: {
        urlImagen(imagen) {
            return Utiles.generarURL(imagen);
        },

        numeroEstrellas(total){
            return  parseFloat(total*5/this.numeroMayor)
        }
    }
}
</script>
